import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useI18next } from 'gatsby-plugin-react-i18next'

import Header from './header'
import Footer from './footer'

import WhatsappIcon from '../images/whatsapp.inline.svg'
import { useGlobalDataIT } from './use-global-data-it'
import { useGlobalDataEN } from './use-global-data-en'

const Layout = ({ children, className, pathname, hasLightBg, simpleHeader, alwaysBlack }) => {
  const { language } = useI18next()
  const globalInfo_EN = useGlobalDataEN()
  const globalInfo_IT = useGlobalDataIT()

  function getGlobalData() {
    if (language === 'it') {
      return globalInfo_IT
    }
    return globalInfo_EN
  }

  return (
    <>
      {globalInfo_EN && globalInfo_IT && (
        <Header
          globalData={getGlobalData()}
          hasLightBg={hasLightBg}
          simpleHeader={simpleHeader}
          alwaysBlack={alwaysBlack}
        />
      )}

      <div className={`${className}`}>
        <main>{children}</main>

        {globalInfo_EN && globalInfo_IT && <Footer globalData={getGlobalData()} />}
      </div>
      <div className="whatsapp-wrapper">
        <a href="https://wa.me/+393899595221" target="_blank" rel="noreferrer" color="#4dc247">
          <WhatsappIcon />
        </a>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
